import { Injectable, signal } from '@angular/core';

@Injectable({ providedIn: 'root' })
export class DemoService {
  readonly isOpen = signal(false);
  readonly source = signal<string | null>(null);

  open(source?: string): void {
    this.source.set(source ?? null);
    this.isOpen.set(true);
  }

  close(): void {
    this.isOpen.set(false);
  }
}
